<template>
  <div>
    <div class="asc-custom-alert-airline-report-type-choice">
      <div
        class="asc-custom-alert-airline-report-type-choice-options--container"
      >
        <div class="asc-custom-alert-airline-report-type-choice-options">
          <asc-label
            class="asc-custom-alert-airline-report-type-choice--label"
            size="md"
            :value="information"
          ></asc-label>
          <asc-autocomplete-selector
            v-if="showAirline"
            v-model="airlineSelect"
            :items="airlinesData"
            label="Airline"
            class="asc-child-options"
            :on-change="handleAirlineChange"
            placeholder="Select Airline"
            :component-type="'single'"
            dense
            drop-down-size-matches
            fixed-position
            short
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div v-if="showAirline && showPlatform" class="asc-empty-div"></div>
          <asc-autocomplete-selector
            v-if="showPlatform"
            v-model="platformSelect"
            :items="platformsData"
            label="Platform"
            class="asc-child-options"
            :on-change="handlePlatformChange"
            placeholder="Select Platform"
            :component-type="'single'"
            dense
            drop-down-size-matches
            fixed-position
            short
            :disabled="platformDisable"
            @input="handleInput()"
          ></asc-autocomplete-selector>
          <div
            v-if="
              (showPlatform && showReportType) ||
              (showAirline && showReportType)
            "
            class="asc-empty-div"
          ></div>
          <asc-autocomplete-selector
            v-if="showReportType"
            v-model="reportType"
            :items="reportTypesData"
            label="Report Type"
            class="asc-child-options"
            :on-change="handleReportChange"
            :component-type="'single'"
            placeholder="Select Report Type"
            no-array
            dense
            drop-down-size-matches
            fixed-position
            short
            :disabled="reportTypeDisable"
            @input="handleInput()"
          ></asc-autocomplete-selector>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AscAutocompleteSelector from './AscAutocompleteSelector'
import AscLabel from '../atoms/AscLabel.vue'
import {
  LOOKUP_CONSTS as LC,
  ACMF_REPORT_LIST_CONSTS as ARLC,
  USER_CONSTS as UC,
} from '@/stores/consts'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'AscCustomAlertAirlineReportTypeChoice',

  components: {
    AscAutocompleteSelector,
    AscLabel,
  },

  props: {
    value: {
      type: Object,
      default: null,
    },
    reportTypes: {
      type: Array,
      default: () => [],
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    platforms: {
      type: Array,
      default: () => [],
    },
    showAirline: {
      type: Boolean,
      default: false,
    },
    showReportType: {
      type: Boolean,
      default: false,
    },
    showPlatform: {
      type: Boolean,
      default: false,
    },
    information: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      reportType:
        this.value && this.value.reportType ? this.value.reportType : null,
      airlineSelect:
        this.value && this.value.airlineSelect
          ? this.value.airlineSelect
          : this.airlines?.length === 1
          ? [this.airlines[0].value]
          : null,
      platformSelect:
        this.value && this.value.platformSelect
          ? this.value.platformSelect
          : this.platforms?.length === 1
          ? [this.platforms[0].value]
          : null,
      selectedItems: null,
      airlineWithMasterModel: null,
      platformMasterModel: null,
    }
  },

  computed: {
    ...mapState(LC.NAMESPACE, ['airlineMasterModelAgreement']),
    ...mapState(ARLC.NAMESPACE, ['acmfReportAirlineMasterModelAgreement']),
    ...mapGetters(UC.NAMESPACE, ['isAirlineUser', 'isAcmfUser']),
    reportTypesData() {
      if (this.airlineWithMasterModel && this.platformSelect) {
        const filteredReports = this.reportTypes.filter(report => {
          return this.platformSelect.includes(report.masterModelId)
        })
        return filteredReports
      }
      return this.reportTypes
    },

    airlinesData() {
      return this.airlines
    },
    platformsData() {
      let airlinewithMasterModel =
        this.isAcmfUser && !this.isAirlineUser
          ? this.acmfReportAirlineMasterModelAgreement
          : this.airlineMasterModelAgreement
      if (this.airlineWithMasterModel) {
        const mappedmastermodels = airlinewithMasterModel.find(item => {
          return item.airlineId === this.airlineWithMasterModel.airlineId
        })
        const mappedValidAgreementMasterModels =
          mappedmastermodels.platformAgreementData
            .filter(item => item.agreementTypeId > 0)
            .map(item => {
              return {
                masterModelId: item.value,
              }
            })

        let validMasterModels = []
        mappedValidAgreementMasterModels.forEach(item => {
          validMasterModels.push(item.masterModelId)
        })

        const filteredPlatforms = this.platforms.filter(platform => {
          return validMasterModels.includes(platform.masterModelId)
        })
        return filteredPlatforms
      }
      return this.platforms
    },
    platformDisable() {
      return !this.showAirline || this.airlineSelect ? false : true
    },
    reportTypeDisable() {
      return (!this.showAirline && !this.showPlatform) || this.platformSelect
        ? false
        : true
    },
  },

  mounted() {
    this.handleInput()
  },

  methods: {
    handleAirlineChange(id, selection, selectionObject = []) {
      this.selectedItems.airlineText = selectionObject[0].text
        ? selectionObject[0].text
        : ''
      if (this.showAirline) {
        if (this.showPlatform) {
          this.platformSelect = null
          this.selectedItems.platformSelect = ''
          this.selectedItems.platformText = ''
        }
        this.reportType = null
        this.selectedItems.reportType = null
      }
      this.emitInput({ ...this.selectedItems })
    },
    handleReportChange(id, selection, selectionObject = []) {
      this.selectedItems.reportText = selectionObject[0].text
        ? selectionObject[0].text
        : ''
      this.emitInput({ ...this.selectedItems })
    },
    handlePlatformChange(id, selection, selectionObject = []) {
      this.selectedItems.platformText = selectionObject[0].text
        ? selectionObject[0].text
        : ''
      if (this.showPlatform) {
        this.reportType = null
        this.selectedItems.reportType = null
      }
      this.emitInput({ ...this.selectedItems })
    },
    handleInput() {
      let data = null
      if (this.airlineSelect) {
        const airlineName = this.airlines.filter(airlineObj => {
          return airlineObj.value === this.airlineSelect[0]
        })
        this.airlineWithMasterModel = airlineName[0]
      }
      if (this.platformSelect) {
        const platformValue = this.platforms.find(platformObj => {
          return platformObj.value === this.platformSelect[0]
        })
        this.platformMasterModel = platformValue
      }
      if (
        this.airlines.length === 1 &&
        !this.showAirline &&
        !this.showPlatform &&
        this.showReportType
      ) {
        data = {
          reportType: this.reportType ? this.reportType : null,
          airlineSelect: this.airlines[0].airlineId,
          platformSelect: this.platforms[0].value,
          platformText: this.platforms.find(x => x.value == this.platformSelect)
            .text,
        }
      } else if (
        this.airlines.length === 1 &&
        !this.showAirline &&
        !this.showReportType &&
        this.showPlatform
      ) {
        data = {
          reportType: this.reportType ? this.reportType : null,
          airlineSelect: this.airlines[0].airlineId,
          platformSelect: this.platformMasterModel
            ? this.platformMasterModel.value
            : null,
        }
      } else if (
        this.airlines.length > 1 &&
        !this.showAirline &&
        this.showPlatform &&
        this.showReportType
      ) {
        data = {
          reportType: this.reportType ? this.reportType : null,
          airlineSelect: this.airlines[0].airlineId,
          platformSelect: this.platformMasterModel
            ? this.platformMasterModel.value
            : null,
        }
      } else if (this.showAirline && !this.showPlatform) {
        data = {
          reportType: this.reportType ? this.reportType : null,
          airlineSelect: this.airlineWithMasterModel
            ? this.airlineWithMasterModel.airlineId
            : null,
          platformSelect: this.platforms[0].value,
        }
      } else {
        data = {
          reportType: this.reportType ? this.reportType : null,
          airlineSelect: this.airlineWithMasterModel
            ? this.airlineWithMasterModel.airlineId
            : null,
          platformSelect: this.platformMasterModel
            ? this.platformMasterModel.value
            : null,
        }
      }
      this.selectedItems = { ...this.selectedItems, ...data }
      if (this.airlines.length === 1 && !this.showAirline)
        this.handleAirlineChange('', '', this.airlines)
      else if (
        this.airlines.length === 1 &&
        this.showAirline &&
        this.reportType == null
      )
        this.emitInput({ ...this.selectedItems })
      if (this.platforms.length === 1 && !this.showPlatform)
        this.handlePlatformChange('', '', this.platforms)
      else if (
        this.platforms.length === 1 &&
        this.showPlatform &&
        this.reportType == null
      )
        this.emitInput({ ...this.selectedItems })
    },
    emitInput(data) {
      this.$emit('input', data)
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alert-airline-report-type-choice {
  padding: 20px 10px;

  & .asc-empty-div {
    height: 30px;
  }
}
</style>
